<script setup lang="ts">
import { cn } from "@/lib/utils";
import { eventBus } from "#bb/lib/eventBus";

// 1) Expect 'id' from the parent.
const props = defineProps<{ id: string }>();
const emit = defineEmits(["content-update"]);

// 2) Get the definition data (read-only) from the content manager.
const { getContentById } = useContentManager();
const definitionData = computed(() => getContentById(props.id));


// 4) Define commands for the context menu.
const commands = [
  {
    id: "editors-group",
    type: "group",
    name: "Editors",
    description: "Card editors",
    commands: [
      {
        id: "edit",
        name: "Edit Card",
        description: "Edit card settings",
        action: async () => {
          eventBus.emit(`component:onEdit:${props.id}`, {
            data: { ...definitionData.value },
          });
        },
        icon: "lucide:edit",
      },
    ],
  },
];

defineExpose({
  commands,
  properties: {
    id: props.id,
    name: "Card",
    icon: "lucide:square-dashed-bottom-code",
  },
  filter: ["Card Header", "Card Content", "Card Footer"],
});
</script>

<template>
  <!-- The main ShadCN Card component with a slot for nested content -->
  <Card :class="cn($attrs.class ?? '')">
    <slot />
  </Card>

</template>

<script lang="ts">
import { ComponentDefinitionIds } from "#bb/lib/componentDefinitionIds";
export default {
  componentId: ComponentDefinitionIds.CARD,
  icon: "lucide:square-dashed-bottom-code",
  type: "Card",
  description: "A container block that provides a card layout for nested elements.",
  default: {},
  categories: ["Layout"],
  filter: ["Card Header", "Card Content", "Card Footer"],
  order: 12001,
};
</script>
